import React from 'react';

import { Wrapper } from './SearchFilterCourseItem.styles'

import { MEDIABASE } from '../../common/constants';

const ASSET_URL = MEDIABASE + 'assets/';

interface Props {icon?: string, sfId: number, onCourseClick: any, selected: number, isActive: boolean, onShowVideo?: any }

function SearchFilterCourseItem(props: Props) {
    const {icon, sfId, onCourseClick, selected, isActive, onShowVideo} = props;

    const onClick = () => onCourseClick(sfId)

    const onPlayClick = () => onShowVideo(sfId);

    return (
      <Wrapper isActive={isActive} isCurrent={selected === sfId}>
        <img
          onClick={onClick}
          className="course-icon"
          src={ASSET_URL + icon}
          alt=""
        />
        <i onClick={onPlayClick} className="fa fa-play-circle video-cta" />
      </Wrapper>
    );
}

export default SearchFilterCourseItem



// WEBPACK FOOTER //
// ./src/common/CourseDisplays/SearchFilterCourseItem.tsx